const LAYOUTS = {
  APP: 'AppLayout',
  MAIN: 'MainLayout',
  BASE: 'BaseLayout',
  COMPANIES: 'CompaniesLayout',
  AUTH: 'AuthLayout',
  SETTINGS: 'SettingsLayout',
};

Object.freeze(LAYOUTS);

export default LAYOUTS;
